export const GRID_COLS = 6;

export type ArcadeKeyMapping = {
  type: 'button' | 'axis';
  index: number;
  value?: number;
};

// P1: WASD + UIOJKL + 1 (start)
export const KEY_MAP_P1: Record<string, ArcadeKeyMapping> = {
  w: { type: 'axis', index: 1, value: -1 },
  s: { type: 'axis', index: 1, value: 1 },
  a: { type: 'axis', index: 0, value: -1 },
  d: { type: 'axis', index: 0, value: 1 },
  u: { type: 'button', index: 0 },
  i: { type: 'button', index: 1 },
  o: { type: 'button', index: 2 },
  j: { type: 'button', index: 3 },
  k: { type: 'button', index: 4 },
  l: { type: 'button', index: 5 },
  '1': { type: 'button', index: 9 },
};

// P2: Arrows + RTYFGH + 2 (start)
export const KEY_MAP_P2: Record<string, ArcadeKeyMapping> = {
  arrowup: { type: 'axis', index: 1, value: -1 },
  arrowdown: { type: 'axis', index: 1, value: 1 },
  arrowleft: { type: 'axis', index: 0, value: -1 },
  arrowright: { type: 'axis', index: 0, value: 1 },
  r: { type: 'button', index: 0 },
  t: { type: 'button', index: 1 },
  y: { type: 'button', index: 2 },
  f: { type: 'button', index: 3 },
  g: { type: 'button', index: 4 },
  h: { type: 'button', index: 5 },
  '2': { type: 'button', index: 9 },
};

export type ArcadeNavigationDirection = 'up' | 'down' | 'left' | 'right';

/**
 * Moves the selection around the game grid, clamping at every edge.
 * Returns the current index unchanged when the move is not possible.
 */
export function nextGridIndex(
  currentIndex: number,
  direction: ArcadeNavigationDirection,
  gamesLength: number,
): number {
  const row = Math.floor(currentIndex / GRID_COLS);
  const col = currentIndex % GRID_COLS;
  const totalRows = Math.ceil(gamesLength / GRID_COLS);

  switch (direction) {
    case 'up':
      if (row > 0) {
        return currentIndex - GRID_COLS;
      }
      break;
    case 'down':
      if (row < totalRows - 1) {
        const nextIndex = currentIndex + GRID_COLS;
        if (nextIndex < gamesLength) {
          return nextIndex;
        }
      }
      break;
    case 'left':
      if (col > 0) {
        return currentIndex - 1;
      }
      break;
    case 'right':
      if (col < GRID_COLS - 1 && currentIndex + 1 < gamesLength) {
        return currentIndex + 1;
      }
      break;
  }

  return currentIndex;
}
